import { Grid, Typography, Card, Button } from '@mui/material'
import { ReactComponent as LockIcon } from '../../../../icons/lockIcon.svg';
import { ReactComponent as Lock } from '../../../../icons/lock.svg';
import React from 'react'
import colors from '../../../colors';
import { texts } from '../../../general/texts';
import ForgotPassword from './ForgotPassword';
import LoggedDevices from './LoggedDevices';
import DevicesIcon from '@mui/icons-material/Devices';
import ChangePin from './ChangePin';
import PinIcon from '@mui/icons-material/Pin';

export const Security = () => {

  const searchMethods = ['0', '1', '2', '3']

  const [state, setState] = React.useState({
    selectedSearchMethod: searchMethods[0],
  })

  const getSearchMethodValue = (value) => {
    setState({ ...state, selectedSearchMethod: value })
  }

  const handleBackButtonClick = () => {
    setState({ ...state, selectedSearchMethod: '0' });
  };

  return (
    <Grid container justifyContent={'center'} pt={'3%'} >
      <Card sx={{ width: '1100px', minHeight: '750px', boxShadow: '0 0 15px 5px #E5E7EA', borderRadius: '20px', '@media (max-width: 899px)': { width: '90%', minHeight: '90vh', marginTop: '5%' } }} >
        <Grid container rowSpacing={7} pt={'3%'} pb={'8%'} >
          <Grid container item md={12} xs={12} >
            <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ backgroundColor: colors.cyan, borderRadius: '20px', width: '60px', height: '60px', marginLeft: '3%' }}>
              <LockIcon />
            </Grid>
            <Typography sx={{ color: colors.darkBlue, fontSize: '1.5rem', fontFamily: 'GerberaBold', paddingTop: '1%', paddingLeft: '2%' }} >{texts["placeholder-security"]}</Typography>
          </Grid>
          <Grid container item rowSpacing={5} pl={'3%'} >
            {state.selectedSearchMethod === '0' && (
              <>
                <Grid container justifyContent={'center'} sx={{ mt: '12%', pb: '4%' }}>
                  <Card elevation={0} sx={{ backgroundColor: colors.cyan, width: '50%', borderRadius: '20px', '@media (max-width: 899px)': { width: '90%' } }}>
                    <Button onClick={() => { getSearchMethodValue('1') }} sx={{ ":hover": { backgroundColor: colors.lightGray }, width: '100%', height: "100%", paddingBottom: '7%' }} >
                      <Grid item container md={12} xs={12} >
                        <Grid item md={3} xs={4} sx={{ pt: '8%' }} >
                          <Lock />
                        </Grid>
                        <Grid item md={9} xs={8} sx={{ paddingTop: '10%', pl: '8%' }}>
                          <Typography sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight', textTransform: 'none' }} textAlign='left' >{texts["button-change-password"]}</Typography>
                        </Grid>
                      </Grid>
                    </Button>
                  </Card>
                </Grid>
                <Grid container justifyContent={'center'} sx={{ pb: '4%' }}>
                  <Card elevation={0} sx={{ backgroundColor: colors.cyan, width: '50%', borderRadius: '20px', '@media (max-width: 899px)': { width: '90%' } }}>
                    <Button onClick={() => { getSearchMethodValue('2') }} sx={{ ":hover": { backgroundColor: colors.lightGray }, width: '100%', height: "100%", paddingBottom: '7%' }} >
                      <Grid item container md={12} xs={12} >
                        <Grid item md={3} xs={4} sx={{ pt: '8%' }} >
                          <PinIcon color='warning' fontSize='large' />
                        </Grid>
                        <Grid item md={9} xs={8} sx={{ paddingTop: '10%', pl: '8%' }}>
                          <Typography sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight', textTransform: 'none' }} textAlign='left' >{texts["button-change-pin"]}</Typography>
                        </Grid>
                      </Grid>
                    </Button>
                  </Card>
                </Grid>
                <Grid container justifyContent={'center'} sx={{ pb: '10%' }}>
                  <Card elevation={0} sx={{ backgroundColor: colors.cyan, width: '50%', borderRadius: '20px', '@media (max-width: 899px)': { width: '90%' } }}>
                    <Button onClick={() => { getSearchMethodValue('3') }} sx={{ ":hover": { backgroundColor: colors.lightGray }, width: '100%', height: "100%", paddingBottom: '7%' }} >
                      <Grid item container md={12} xs={12} >
                        <Grid item md={3} xs={4} sx={{ pt: '8%' }} >
                          <DevicesIcon color='warning' fontSize='large' />
                        </Grid>
                        <Grid item md={9} xs={8} sx={{ paddingTop: '10%', pl: '8%' }}>
                          <Typography sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight', textTransform: 'none' }} textAlign='left' >{texts["logged-devices"]}</Typography>
                        </Grid>
                      </Grid>
                    </Button>
                  </Card>
                </Grid>
              </>
            )}
          </Grid>
          {state.selectedSearchMethod === '1' ? <ForgotPassword onBackButtonClick={handleBackButtonClick} /> : null}
          {state.selectedSearchMethod === '2' ? <ChangePin onBackButtonClick={handleBackButtonClick} /> : null} 
          {state.selectedSearchMethod === '3' ? <LoggedDevices onBackButtonClick={handleBackButtonClick} /> : null} 
        </Grid>
      </Card>
    </Grid>
  )
}

export default Security